import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";
import { initTabs } from "../../../src/js/modules/tabs";

document.querySelectorAll(".js-recent-projects").forEach((el) => {
	initTabs(el);
	initOnScrollAnimation(el);
});
